(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/draw-count.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/draw-count.js');

'use strict';

svs.numbergames.game.views.DrawCount = Marionette.View.extend({
  MULTIPLE_LINE_BREAKPOINT: 5,
  viewOptions: ['possibleDrawCounts', 'drawCountHeader', 'hasSubscription'],
  className: 'numbergames-footer-section numbergames-draw-count',
  regions: {
    drawDateRegion: '#drawDateRegion'
  },
  ui: {
    drawCountRadio: '.js-draw-count-radio'
  },
  triggers: {
    'change @ui.drawCountRadio': 'setDrawCount'
  },
  modelEvents: {
    'change:isSyndicate': 'onChangeIsSyndicate',
    'change:drawCount': 'onChangeDrawCount'
  },
  template(data) {
    return svs.numbergames.game.templates.draw_count(data);
  },
  templateContext() {
    return {
      possibleDrawCounts: this.possibleDrawCounts,
      useMultipleLines: this.possibleDrawCounts.length > this.MULTIPLE_LINE_BREAKPOINT,
      hasSubscription: this.hasSubscription,
      drawCountHeader: this.drawCountHeader
    };
  },
  async initialize() {
    this.mergeOptions(this.options, this.viewOptions);
    if (this.hasSubscription) {
      this.possibleDrawCounts.push({
        value: 'subscription',
        label: 'Prenumerera'
      });
    }
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      return;
    }
    const activeAccount = await svs.numbergames.accountSelector.getActiveAccount();
    if (activeAccount !== null && activeAccount !== void 0 && activeAccount.isSyndicate && this.model.get('isSubscription')) {
      this.model.set('drawCount', '1');
    }
  },
  onRender() {
    const {
      alwaysOpen
    } = svs.numbergames.game_model.rulesRadio.request('rules');
    if (alwaysOpen || svs.numbergames.game.draw.isOpen || svs.numbergames.game.utils.isSelfService()) {
      this.showChildView('drawDateRegion', {
        className: 'numbergames-footer-section-info-text',
        model: this.model,
        modelEvents: {
          'change:drawCount change:selectedDays': 'render'
        },
        template(data) {
          return "<p>".concat(svs.numbergames.draws.drawsUtils.drawDateText(data.productId, data) || '&nbsp;', "</p>");
        }
      });
    } else {
      this.showChildView('drawDateRegion', {
        className: 'numbergames-footer-section-info-text',
        template() {
          return "<p>Omg\xE5ng st\xE4ngd f\xF6r spel. N\xE4sta omg\xE5ng \xF6ppnar ".concat(svs.utils.date.NaturalDateAndTime(svs.numbergames.game.draw.nextOpenTime), ".</p>");
        }
      });
    }
    this.onChangeIsSyndicate();

    this.getUI('drawCountRadio').each((index, el) => {
      if (el.value.toLowerCase() === 'subscription') el.parentNode.classList.add('form-toggle-subscription');
    });
  },
  showCustomTooltip(attachTo) {
    if (!svs.core.detect.feature('ft-subscription-popup-play') || this.model.get('isSubscription') || this.model.get('isSyndicate')) return;
    const branding = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    const tooltip = document.createElement('div');
    tooltip.className = 'subscription-tooltip';
    tooltip.innerHTML = 'Missa aldrig<br/>en dragning!';

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          attachTo.classList.add('animate-subscription-radio-btn', branding);
          attachTo.appendChild(tooltip);
          observer.disconnect();
        }
      });
    }, {
      threshold: 1
    });
    observer.observe(attachTo);
    this._subscriptionObserver = observer;
  },
  onSetDrawCount(view, event) {
    let actionValue = svs.numbergames.productMapping.isKeno(this.model.get('productId')) ? "".concat(event.target.value, " dagar") : "".concat(event.target.value, " veckor");
    if (event.target.value === 'subscription') {
      actionValue = 'Prenumerera';
    }
    svs.components.analytics.trackEvent({
      category: "".concat(svs.numbergames.productMapping.getProductName(this.model.get('productId')), " Page"),
      action: actionValue,
      opt_label: 'click draws'
    });
    this.model.set({
      drawCount: event.target.value
    });
  },
  onChangeIsSyndicate() {
    this.getUI('drawCountRadio').each((index, el) => {
      if (el.value === 'subscription') {
        el.disabled = this.model.get('isSyndicate');
        setTimeout(() => {
          this.showCustomTooltip(el.parentNode);
        }, 1200);
      }
    });
  },
  onChangeDrawCount(model, drawCount) {
    const radioButtons = this.getUI('drawCountRadio');
    radioButtons.each((i, el) => {
      const radioValue = el.value;
      const $el = $(el);
      const isChecked = $el.prop('checked');
      if (isChecked === (radioValue === drawCount)) {
        return;
      }
      $el.prop({
        checked: radioValue === drawCount
      });
    });
  },
  onBeforeDestroy() {
    if (svs.core.detect.feature('ft-subscription-popup-play')) {
      var _this$_subscriptionOb;
      (_this$_subscriptionOb = this._subscriptionObserver) === null || _this$_subscriptionOb === void 0 || _this$_subscriptionOb.disconnect();
      this._subscriptionObserver = null;
    }
  }
});

 })(window);